// Lib
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { elementModalElementIdSet, elementModalElementIdClear } from './elementModalActions';

const mapDispatchToProps = (dispatch) => ({
    dispatchCurrentElementIdSet: (elementId) => dispatch(elementModalElementIdSet(elementId)),
    dispatchCurrentElementIdClear: () => dispatch(elementModalElementIdClear()),
});

export default (DecoratedComponent) => {
    const elementModalElementIdSynchroniser = ({
        dispatchCurrentElementIdSet,
        dispatchCurrentElementIdClear,
        params: { elementId },
        ...props
    }) => {
        useEffect(() => {
            dispatchCurrentElementIdSet(elementId);
        }, [elementId]);

        useEffect(() => () => dispatchCurrentElementIdClear(), []);

        return <DecoratedComponent elementId={elementId} {...props} />;
    };

    elementModalElementIdSynchroniser.propTypes = {
        params: PropTypes.object,
        dispatchCurrentElementIdSet: PropTypes.func,
        dispatchCurrentElementIdClear: PropTypes.func,
    };

    return connect(null, mapDispatchToProps)(elementModalElementIdSynchroniser);
};
